const initialState = {
    dataKritikSarans:[],
    dataKritikSaran:'',
    modalKritikSaran: false,
    formKritikSaran: {
        Id:null,
        Name: '',
        Email: '',
        Mobile: '',
        DatasetSuggestion: '',
        DatasetReason: '',
        UserSuggestionCategory: '',
        DatasetCategory: '',
        Status: ''
    }
}

const kritikSaranReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_KRITIKSARAN':
            return { ...state, modalKritikSaran: action.payload }
        case 'DATA_KRITIKSARANS':
            return { ...state, dataKritikSarans: action.payload }
        case 'DATA_KRITIKSARAN':
            return { ...state, dataKritikSaran: action.payload }
        case 'RESET_FORM_KRITIKSARAN':
            return { ...state, formKritikSaran: initialState.formKritikSaran }
        case 'FORM_KRITIKSARAN':
            return {
                ...state,
                formKritikSaran: {
                    ...state.formKritikSaran,
                    [action.formType]: action.formValue
                }
            }
        default:
            return state
    }
}

export default kritikSaranReducer;